import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import * as activePublication from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {select, Store} from '@ngrx/store';
import {AppState, selectActivePublicationState} from '@store/app.states';
import {distinctUntilChanged} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {PublicationLinksService} from '@app/components/publications/publication-sideBar/publication-links/publication-links.service';
import {ToastrService} from 'ngx-toastr';
import {ClipboardService} from 'ngx-clipboard';
import {TranslateService} from '@ngx-translate/core';
import {areCommunitiesRefreshing} from '@store/selectors/project.selector';
import {environment} from '@environments/environment';
@Component({
    selector: 'app-cint-link',
    templateUrl: './cint-link.component.html',
    styleUrls: ['./cint-link.component.scss'],
    standalone: false
})
export class CintLinkComponent extends OnDestroyMixin implements OnInit {

  environment = environment;

  @Input()
  selectedLang = 'fr';

  @Input()
  modeTestSelected = false;

  @Input()
  displayTitle = false;

  @Input()
  forceLang = null;

  @Input()
  askLang = false;

  utms: { key: string, value: string }[] = [];

  pubUuid: string = null;

  // areCommunitiesRefreshing$: Observable<boolean> = this.store
  //   .pipe(
  //     select(areCommunitiesRefreshing),
  //     untilComponentDestroyed(this),
  //   );

  getActivePublication$: Observable<activePublication.State> = this.store
    .pipe(
      select(selectActivePublicationState),
      distinctUntilChanged(),
      untilComponentDestroyed(this),
    );


  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private publicationLinksService: PublicationLinksService,
    private toastr: ToastrService,
    private clipboard: ClipboardService
  ) {
    super();
  }

  ngOnInit(): void {

    this.getActivePublication$.pipe(untilComponentDestroyed(this)).subscribe((data) => {
      if (data.datas) {
        this.pubUuid = data.datas.uuid;
        this.utms = data.datas?.linkInfos?.utm || [];
      }
    });

  }

  getUrlLink(projectSlug: string, comId: number, isCint: boolean = false, v2Link = false): string {

    return this.publicationLinksService.getPublicationPublicLink({
      pubUuid: this.pubUuid,
      lang: this.selectedLang as string,
      projectSlug,
      comId,
      isCint,
      testMode: this.modeTestSelected as boolean,
      directMode: false,
      utms: this.utms,
      forceLang: this.forceLang,
      v2Link,
      askLang: this.askLang,
    });

  }

  copyClipBoardUrl(url): void {
    this.clipboard.copy(url);

    this.toastr.info(this.translate.instant('Lien copié dans le presse papier.'), this.translate.instant('Presse papier'), {
      timeOut: 2000,
      progressBar: true,
    });

  }

  gotoUrl(url): void {
    // console.log(url);
    window.open(url, '_blank');
  }


}
